// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { useEffect, useState } from "react";

let failureMessage: string | null = null;
const listeners = new Set<() => void>();

function publish(next: string | null): void {
  if (failureMessage === next) {
    return;
  }
  failureMessage = next;
  listeners.forEach((listener) => listener());
}

export function notifySignInFailed(message: string): void {
  publish(message);
}

export function resetSignInFailure(): void {
  publish(null);
}

export function signInFailureMessage(): string | null {
  return failureMessage;
}

export function useSignInFailure(): string | null {
  const [value, setValue] = useState(failureMessage);

  useEffect(() => {
    const listener = () => setValue(failureMessage);
    listeners.add(listener);
    listener();
    return () => {
      listeners.delete(listener);
    };
  }, []);

  return value;
}
